/** Display publication dates as UTC calendar dates, not viewer-local instants. */
export function formatBlogDate(dateString) {
  if (!dateString) return null
  return new Date(dateString).toLocaleDateString("en-US", {
    timeZone: "UTC",
    month: "long",
    day: "2-digit",
    year: "numeric",
  })
}
